import React from "react";
import "./Contact.css";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";

function Contact() {
  return (
    <section className="contact" id="contact">

  <div class="floating-blob blob1"></div>
  <div class="floating-blob blob2"></div>
  <div class="floating-blob blob3"></div>
  <div class="floating-blob blob4"></div>

      <div className="contact-content">
        <h2>Let’s Build Something Amazing Together 🚀</h2>
        <p>
          I'm always open to collaborations, exciting projects, or just a friendly chat.
        </p>

        <div className="social-links">
          <a
            href="mailto:khanalsanjana01@gmail.com"
            aria-label="Email"
            className="social-link"
          >
            <FaEnvelope className="icon" />
          </a>

          <a
            href="https://www.linkedin.com/in/sanjana-khanal-b104822b8/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="social-link"
          >
            <FaLinkedin className="icon" />
          </a>

          <a
            href="https://github.com/khanalsanjana"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="social-link"
          >
            <FaGithub className="icon" />
          </a>
        </div>
      </div>

      <div className="wave"></div>
    </section>
  );
}

export default Contact;
